/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * When the form expires
 * @export
 * @interface ExpiresAt
 */
export interface ExpiresAt {
}

/**
 * Check if a given object implements the ExpiresAt interface.
 */
export function instanceOfExpiresAt(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExpiresAtFromJSON(json: any): ExpiresAt {
    return ExpiresAtFromJSONTyped(json, false);
}

export function ExpiresAtFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpiresAt {
    return json;
}

export function ExpiresAtToJSON(value?: ExpiresAt | null): any {
    return value;
}

